module.exports = __webpack_public_path__ + "img/logotipologin.f8853159.png";